/* eslint-disable  @typescript-eslint/no-explicit-any */
export const debounce = <F extends (...params: any[]) => void>(cb: F, ms: number): F => {
  let timer: ReturnType<typeof setTimeout>;

  return function fn(this: any, ...args: any[]) {
    clearTimeout(timer);
    timer = setTimeout(() => cb.apply(this, args), ms);
  } as F;
};
